/**
 * @fileoverview gRPC-Web generated client stub for acompanha.printers.v1
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v4.25.2
// source: acompanha/printers/v1/printers.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var acompanha_common_v1_common_pb = require('../../../acompanha/common/v1/common_pb.js')

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')
const proto = {};
proto.acompanha = {};
proto.acompanha.printers = {};
proto.acompanha.printers.v1 = require('./printers_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.acompanha.printers.v1.PrintersServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.acompanha.printers.v1.PrintersServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.printers.v1.ListPrintersRequest,
 *   !proto.acompanha.printers.v1.ListPrintersResponse>}
 */
const methodDescriptor_PrintersService_ListPrinters = new grpc.web.MethodDescriptor(
  '/acompanha.printers.v1.PrintersService/ListPrinters',
  grpc.web.MethodType.UNARY,
  proto.acompanha.printers.v1.ListPrintersRequest,
  proto.acompanha.printers.v1.ListPrintersResponse,
  /**
   * @param {!proto.acompanha.printers.v1.ListPrintersRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.printers.v1.ListPrintersResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.printers.v1.ListPrintersRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.printers.v1.ListPrintersResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.printers.v1.ListPrintersResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.printers.v1.PrintersServiceClient.prototype.listPrinters =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.printers.v1.PrintersService/ListPrinters',
      request,
      metadata || {},
      methodDescriptor_PrintersService_ListPrinters,
      callback);
};


/**
 * @param {!proto.acompanha.printers.v1.ListPrintersRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.printers.v1.ListPrintersResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.printers.v1.PrintersServicePromiseClient.prototype.listPrinters =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.printers.v1.PrintersService/ListPrinters',
      request,
      metadata || {},
      methodDescriptor_PrintersService_ListPrinters);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.printers.v1.GetPrinterRequest,
 *   !proto.acompanha.printers.v1.GetPrinterResponse>}
 */
const methodDescriptor_PrintersService_GetPrinter = new grpc.web.MethodDescriptor(
  '/acompanha.printers.v1.PrintersService/GetPrinter',
  grpc.web.MethodType.UNARY,
  proto.acompanha.printers.v1.GetPrinterRequest,
  proto.acompanha.printers.v1.GetPrinterResponse,
  /**
   * @param {!proto.acompanha.printers.v1.GetPrinterRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.printers.v1.GetPrinterResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.printers.v1.GetPrinterRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.printers.v1.GetPrinterResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.printers.v1.GetPrinterResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.printers.v1.PrintersServiceClient.prototype.getPrinter =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.printers.v1.PrintersService/GetPrinter',
      request,
      metadata || {},
      methodDescriptor_PrintersService_GetPrinter,
      callback);
};


/**
 * @param {!proto.acompanha.printers.v1.GetPrinterRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.printers.v1.GetPrinterResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.printers.v1.PrintersServicePromiseClient.prototype.getPrinter =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.printers.v1.PrintersService/GetPrinter',
      request,
      metadata || {},
      methodDescriptor_PrintersService_GetPrinter);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.printers.v1.CreatePrinterRequest,
 *   !proto.acompanha.printers.v1.CreatePrinterResponse>}
 */
const methodDescriptor_PrintersService_CreatePrinter = new grpc.web.MethodDescriptor(
  '/acompanha.printers.v1.PrintersService/CreatePrinter',
  grpc.web.MethodType.UNARY,
  proto.acompanha.printers.v1.CreatePrinterRequest,
  proto.acompanha.printers.v1.CreatePrinterResponse,
  /**
   * @param {!proto.acompanha.printers.v1.CreatePrinterRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.printers.v1.CreatePrinterResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.printers.v1.CreatePrinterRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.printers.v1.CreatePrinterResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.printers.v1.CreatePrinterResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.printers.v1.PrintersServiceClient.prototype.createPrinter =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.printers.v1.PrintersService/CreatePrinter',
      request,
      metadata || {},
      methodDescriptor_PrintersService_CreatePrinter,
      callback);
};


/**
 * @param {!proto.acompanha.printers.v1.CreatePrinterRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.printers.v1.CreatePrinterResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.printers.v1.PrintersServicePromiseClient.prototype.createPrinter =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.printers.v1.PrintersService/CreatePrinter',
      request,
      metadata || {},
      methodDescriptor_PrintersService_CreatePrinter);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.printers.v1.UpdatePrinterRequest,
 *   !proto.acompanha.printers.v1.UpdatePrinterResponse>}
 */
const methodDescriptor_PrintersService_UpdatePrinter = new grpc.web.MethodDescriptor(
  '/acompanha.printers.v1.PrintersService/UpdatePrinter',
  grpc.web.MethodType.UNARY,
  proto.acompanha.printers.v1.UpdatePrinterRequest,
  proto.acompanha.printers.v1.UpdatePrinterResponse,
  /**
   * @param {!proto.acompanha.printers.v1.UpdatePrinterRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.printers.v1.UpdatePrinterResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.printers.v1.UpdatePrinterRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.printers.v1.UpdatePrinterResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.printers.v1.UpdatePrinterResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.printers.v1.PrintersServiceClient.prototype.updatePrinter =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.printers.v1.PrintersService/UpdatePrinter',
      request,
      metadata || {},
      methodDescriptor_PrintersService_UpdatePrinter,
      callback);
};


/**
 * @param {!proto.acompanha.printers.v1.UpdatePrinterRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.printers.v1.UpdatePrinterResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.printers.v1.PrintersServicePromiseClient.prototype.updatePrinter =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.printers.v1.PrintersService/UpdatePrinter',
      request,
      metadata || {},
      methodDescriptor_PrintersService_UpdatePrinter);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.printers.v1.DeletePrinterRequest,
 *   !proto.acompanha.common.v1.DeleteResponse>}
 */
const methodDescriptor_PrintersService_DeletePrinter = new grpc.web.MethodDescriptor(
  '/acompanha.printers.v1.PrintersService/DeletePrinter',
  grpc.web.MethodType.UNARY,
  proto.acompanha.printers.v1.DeletePrinterRequest,
  acompanha_common_v1_common_pb.DeleteResponse,
  /**
   * @param {!proto.acompanha.printers.v1.DeletePrinterRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  acompanha_common_v1_common_pb.DeleteResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.printers.v1.DeletePrinterRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.common.v1.DeleteResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.common.v1.DeleteResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.printers.v1.PrintersServiceClient.prototype.deletePrinter =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.printers.v1.PrintersService/DeletePrinter',
      request,
      metadata || {},
      methodDescriptor_PrintersService_DeletePrinter,
      callback);
};


/**
 * @param {!proto.acompanha.printers.v1.DeletePrinterRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.common.v1.DeleteResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.printers.v1.PrintersServicePromiseClient.prototype.deletePrinter =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.printers.v1.PrintersService/DeletePrinter',
      request,
      metadata || {},
      methodDescriptor_PrintersService_DeletePrinter);
};


module.exports = proto.acompanha.printers.v1;

